import Vue from 'vue';
import App from './App.vue';

import VsoftWebUiSystem from '@vsoft/web-ui-system';
Vue.use(VsoftWebUiSystem);

Vue.config.productionTip = false;

// ========== Vee validate ==========
import { ValidationProvider, extend, localize } from 'vee-validate';
import { required, email } from 'vee-validate/dist/rules';
import ptBR from './utils/validate-pt_BR.json';

// rules.
extend('email', email);
extend('required', required);
extend('cpf', {
    params: [],
    validate: (value) => {
        
        const validCpf = (cpf: string) => {
            const noMaskCpf = cpf.replace(new RegExp('[.-]','gi'), '');
            let Soma;
            let Resto;
            Soma = 0;
            if (noMaskCpf == "00000000000") return false;
            if (noMaskCpf == "11111111111") return false;
            if (noMaskCpf == "22222222222") return false;
            if (noMaskCpf == "33333333333") return false;
            if (noMaskCpf == "44444444444") return false;
            if (noMaskCpf == "55555555555") return false;
            if (noMaskCpf == "66666666666") return false;
            if (noMaskCpf == "77777777777") return false;
            if (noMaskCpf == "88888888888") return false;
            if (noMaskCpf == "99999999999") return false;
             
            for (let i=1; i<=9; i++) Soma = Soma + parseInt(noMaskCpf.substring(i-1, i)) * (11 - i);
            Resto = (Soma * 10) % 11;
           
            if ((Resto == 10) || (Resto == 11))  Resto = 0;
            if (Resto != parseInt(noMaskCpf.substring(9, 10)) ) return false;
           
            Soma = 0;
            for (let i = 1; i <= 10; i++) Soma = Soma + parseInt(noMaskCpf.substring(i-1, i)) * (12 - i);
            Resto = (Soma * 10) % 11;
           
            if ((Resto == 10) || (Resto == 11))  Resto = 0;
            if (Resto != parseInt(noMaskCpf.substring(10, 11) ) ) return false;
            return true;
        };
        const cpf = /^\d{3}\.\d{3}\.\d{3}-\d{2}$/;
        return cpf.test(value) && validCpf(value);
    },
    message: "Por favor, insira um cpf válido"
});

// Install English and Arabic localizations.
localize({
    ptBR: {
        messages: ptBR.messages
    }
});
localize('ptBR');

Vue.component('validation-provider', ValidationProvider);


new Vue({
    render: h => h(App),
}).$mount('#app');
